import { useDynamicConfig, useStatsigClient } from '@statsig/react-bindings';
import { SMPLandingPage } from './SMPLandingPage';
import { SMPLegacy } from './SMPLegacy';
import { SMPMaintenancePage } from './SMPMaintenancePage';
import { SMPLandingPageSkeleton } from './SMPLandingPageSkeleton';
import { useIframeModeStore } from '@/hooks/useIframeModeStore';

export const SMP = () => {
  const { isIframeMode } = useIframeModeStore();
  const { client } = useStatsigClient();
  const isStatsigReady = client.loadingStatus === 'Ready';

  const config = useDynamicConfig('public_config');
  const maintenanceMode = config.get('smp_maintenance_mode', false);
  const enableNewSMP = isIframeMode || config.get('enable_new_smp', false);
  console.log(maintenanceMode, enableNewSMP, 'maintenanceMode, enableNewSMP');

  if (!isStatsigReady) {
    return <SMPLandingPageSkeleton />;
  }

  if (maintenanceMode) {
    return <SMPMaintenancePage />;
  }

  return enableNewSMP ? <SMPLandingPage /> : <SMPLegacy />;
};
